import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useAppDuration, AppDuration } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<AppDuration>
      useData={useAppDuration}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
